import { createAction, props } from '@ngrx/store';
import { DeviceGroup } from './../../../api/models/device-group.model';
import { ThemeStatus } from './../../../api/models/theme-status.model';
import { ScheduleSummary } from './../../../api/models/schedule-summary.model';
import { Update } from '@ngrx/entity';

export const loadThemesStatus = createAction(
    '[Themes Status] Load Themes status via service',
    props<{ locationId: number }>()
);

export const loadThemesStatusSuccess = createAction(
    '[Themes Status] Load Themes status success',
    props<{ themesStatus: ThemeStatus[] }>()
)

export const loadThemesStatusFail = createAction(
    '[Themes Status] Load Themes status failed',
    props<{ error: any }>()
)

export const startPollingThemesStatus = createAction(
    '[Themes Status] Start Polling',
)

export const stopPollingThemesStatus = createAction(
    '[Themes Status] Stop Polling',
)

export const clear = createAction(
    '[Themes Status] Clear all themes statuses'
);
export const themesStatusActions = {
    loadThemesStatus,
    loadThemesStatusSuccess,
    loadThemesStatusFail,
    startPollingThemesStatus,
    stopPollingThemesStatus,
    clear
}